import styled from 'styled-components';
import HappyNewImagePropertySvg from './happyNewImageProperty.svg';

const HappyNewImagePropertyIcon = styled(HappyNewImagePropertySvg as JSX.Element)`
  width: ${props => props.width};
  height: ${props => props.height};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.medium};
`;

export default HappyNewImagePropertyIcon;
